import { asyncLoad } from '@util'
import ChooseCase from '@components/LocalMerchant/ActivityRegister/ChooseCase'
// import activityDetail from './ActivityDetail'
// import chooseCase from './ChooseCase'

const AsyncAllActivity = asyncLoad(() =>
  import('@components/LocalMerchant/ActivityRegister/AllActivity')
)

const AsyncActivityDetail = asyncLoad(() =>
  import('@components/LocalMerchant/ActivityRegister/ActivityDetail')
)

export default {
  path: 'activityRegister',
  indexRoute: {
    component: AsyncAllActivity
  },
  stat: '活动报名/首页',
  childRoutes: [
    {
      path: 'activityDetail/:id',
      component: AsyncActivityDetail,
      stat: '活动报名/活动详情'
    },
    {
      path: 'activityDetail/:id/chooseCase/:positionId',
      component: ChooseCase
    }
  ]
}
